module.exports = __webpack_public_path__ + "img/chevron-down.38d1ac.svg";